import { selectToken } from '../../util/tokenSelector.js';
import { Box } from '../Box/Box.js';
import { getFadeGradients } from './helpers/fadeGradiant.js';
import { useThemeContext } from '../../contexts/session/Theme.js';
import styled from 'styled-components';

var CarouselStyled = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Carouselstyled__CarouselStyled",
  componentId: "sc-1c3gfa7-0"
})(function (_ref) {
  var $fade = _ref.$fade,
    $isSingle = _ref.$isSingle,
    $isRtl = _ref.$isRtl,
    $scrollPaddingLeft = _ref.$scrollPaddingLeft,
    $scrollPaddingStart = _ref.$scrollPaddingStart,
    $scrollPaddingRight = _ref.$scrollPaddingRight,
    $scrollSnap = _ref.$scrollSnap;
  var theme = useThemeContext();
  var textNeutral4Token = selectToken(theme.text, 'base.inverted');
  var textPrimaryInteractiveToken = selectToken(theme.text, 'product.primary');
  var styles = {
    MsOverflowStyle: 'none',
    scrollbarWidth: 'none',
    maskImage: getFadeGradients($isSingle, $fade, $isRtl),
    '::-webkit-scrollbar': {
      display: 'none'
    },
    ':focus-visible': {
      boxShadow: "0 0 0 2px ".concat(textNeutral4Token, ", 0 0 0 4px ").concat(textPrimaryInteractiveToken)
    }
  };
  if ($scrollSnap) {
    var scrollPaddingLeft = $scrollPaddingLeft || !$isRtl && $scrollPaddingStart && "".concat($scrollPaddingStart, "px") || undefined;
    var scrollPaddingRight = $scrollPaddingRight || $isRtl && $scrollPaddingStart && "".concat($scrollPaddingStart, "px") || undefined;
    styles.scrollPaddingLeft = scrollPaddingLeft;
    styles.scrollPaddingRight = scrollPaddingRight;
    styles.scrollBehavior = 'auto';
    styles.scrollSnapType = 'x mandatory';
  }
  return styles;
});

export { CarouselStyled };
//# sourceMappingURL=Carousel.styled.js.map
